import { render } from "./NewProject.vue?vue&type=template&id=1f55d74e&ts=true"
import script from "./NewProject.vue?vue&type=script&lang=ts"
export * from "./NewProject.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\benja\\Desktop\\LolaClean\\Frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__